import { render, staticRenderFns } from "./AppointmentChooseBranchOfficePage.vue?vue&type=template&id=2a003196&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./AppointmentChooseBranchOfficePage.vue?vue&type=script&lang=ts"
export * from "./AppointmentChooseBranchOfficePage.vue?vue&type=script&lang=ts"
import style0 from "./AppointmentChooseBranchOfficePage.vue?vue&type=style&index=0&id=2a003196&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports